import React from 'react';
import { FeatureContextProvider } from 'contexts/FeatureContext.jsx';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5/index.js';

import { LocalizationContextProvider } from 'contexts/LocalizationContext.jsx';
import { UserContextProvider } from 'contexts/UserContext.jsx';
import { TopbarContextProvider } from 'contexts/TopbarContext.jsx';
import { FooterContextProvider } from 'contexts/FooterContext.jsx';
import { TooltipContextProvider } from 'contexts/TooltipContext.jsx';
import { AlertContextProvider } from 'contexts/AlertContext.jsx';
import { NavigationFrameContextProvider } from 'contexts/NavigationFrameContext.jsx';
import { DrawerContextProvider } from 'contexts/DrawerContext.jsx';

import ContextLoader from 'components/ContextLoader/index.jsx';
import NewVersionAlertWrapper from 'components/NewVersionAlertWrapper/index.jsx';
import { SlotProvider } from 'contexts/SlotContext/index.jsx';
import { VideoUploadContextProvider } from 'pages/Videos/hooks/videoUploadContext.jsx';
import { OngoingDubsContextProvider } from 'contexts/OngoingDubsContext.jsx';
import { UserNotificationsContextProvider } from 'contexts/UserNotificationsContext.jsx';
import { DelegatedFrameContextProvider } from 'contexts/DelegatedFrameContext.jsx';
import { BroadcasterProvider } from 'contexts/BroadcasterContext.jsx';

const LayoutContextProviders = ({ children }) => {

  return (
    <FeatureContextProvider>
      <QueryParamProvider adapter={ReactRouter5Adapter}>
        <AlertContextProvider>
          <UserContextProvider>
            <LocalizationContextProvider>
              <ContextLoader>
                <NewVersionAlertWrapper>
                  <UserNotificationsContextProvider>
                    <OngoingDubsContextProvider>
                      <VideoUploadContextProvider>
                        <TopbarContextProvider>
                          <FooterContextProvider>
                            <TooltipContextProvider>
                              <DrawerContextProvider>
                                <SlotProvider>
                                  <NavigationFrameContextProvider>
                                    <DelegatedFrameContextProvider>
                                      <BroadcasterProvider>
                                        {children}
                                      </BroadcasterProvider>
                                    </DelegatedFrameContextProvider>
                                  </NavigationFrameContextProvider>
                                </SlotProvider>
                              </DrawerContextProvider>
                            </TooltipContextProvider>
                          </FooterContextProvider>
                        </TopbarContextProvider>
                      </VideoUploadContextProvider>
                    </OngoingDubsContextProvider>
                  </UserNotificationsContextProvider>
                </NewVersionAlertWrapper>
              </ContextLoader>
            </LocalizationContextProvider>
          </UserContextProvider>
        </AlertContextProvider>
      </QueryParamProvider>
    </FeatureContextProvider>
  );
};

export default LayoutContextProviders;
